document.addEventListener('DOMContentLoaded', () => {

  const sections = document.querySelectorAll('.media-grid-pro');

  sections.forEach(section => {

    const layout = section.dataset.layout;

    if (layout !== 'slider') return;

    const slider = section.querySelector('.media-grid-pro__grid');

    if (!slider || typeof Swiper === 'undefined') return;

    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 16,

      watchOverflow: true,

      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev')
      },

      breakpoints: {
        768: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 3
        },
        1400: {
          slidesPerView: 5
        }
      }
    });

  });

});